export interface Testimonial {
  name: string
  role?: string
  country: string
  /** ISO 3166-1 alpha-2 code, used for the flag image */
  countryCode: string
  text: string
}

/** Real customer reviews go here. The section stays hidden while this list is empty. */
export const testimonials: Testimonial[] = []
